var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layout',{attrs:{"layout":"['xs12']"}},[_c('v-card',[_c('v-form',{ref:"sendConfigForm"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }